module.exports = __webpack_public_path__ + "img/ThreeMotherPot.1a0f36a1.svg";